
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useCallback, useState, useEffect } from "react";

export const usePinPlugins = () => {

  const { data, loading, error } = useAuthedRequest(`/dreamstream/pin/plugins`);
  
  return {
    data,
    error,
    loading
  }
};
